import React from 'react';
import { useIntl } from 'react-intl';

import { Card, CType } from 'entities/card/model/types';
import { GreyContainer } from 'shared/ui';
import { Space } from 'antd';
import CardIcon from 'shared/ui/CardIcon/CardIcon';
import { useNavigate } from 'react-router';
import { ROUTES } from 'shared/const/routes';

type CardsBlockProps = {
  card: Card;
};

const CardsBlock: React.FC<CardsBlockProps> = ({
  card,
}) => {
  const { formatMessage: t } = useIntl();
  const navigate = useNavigate();

  const onCardClick = () => {
    navigate(ROUTES.CARD.path)
  };

  return (
    <GreyContainer title={t({ id: 'sections.card.card.title' })}>
      <div style={{ cursor: 'pointer'}} onClick={onCardClick}>
        <CardIcon
          size="s"
          type={card.type}
          status={card.status}
          cardNumber={card.numberMasked || ''}
        />
      </div>
    </GreyContainer>
  );
};

export default CardsBlock;
